import type { SVGProps } from 'react';
import * as React from 'react';

export const Reload = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.40961 8C6.76304 5.77509 9.20906 4.29199 12 4.29199C16.257 4.29199 19.708 7.74298 19.708 12C19.708 16.257 16.257 19.708 12 19.708C8.04303 19.708 4.78124 16.7255 4.34231 12.8864C4.27958 12.3377 3.78391 11.9437 3.2352 12.0065C2.68649 12.0692 2.29252 12.5649 2.35526 13.1136C2.90835 17.9512 7.01474 21.708 12 21.708C17.3616 21.708 21.708 17.3616 21.708 12C21.708 6.63841 17.3616 2.29199 12 2.29199C8.67955 2.29199 5.7498 3.9592 4.00009 6.49896V4.5C4.00009 3.94772 3.55238 3.5 3.00009 3.5C2.44781 3.5 2.00009 3.94772 2.00009 4.5V9C2.00009 9.55229 2.44781 10 3.00009 10L7.50009 10C8.05238 10 8.50009 9.55229 8.50009 9C8.50009 8.44772 8.05238 8 7.50009 8L5.40961 8Z"
      fill="currentColor"
    />
  </svg>
);
